import { Component, ElementRef, Inject, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';


import {
    // Navigation
    MatMenuModule
} from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AppSettings, DataService, FG_APP_CONSTANTS, FgAppConstants, FgMenuService } from 'fg-library';
@Component({
    selector: 'client-top-nav-menu-item',
    templateUrl: './top-nav-menu-item.component.html',
    styleUrls: ['./top-nav-menu-item.component.scss'],
    standalone: false
})
export class ClientTopNavMenuItemComponent {

    @Input() items: any;
    @Input() localConfig: any;
    @ViewChild('childMenu', { static: true }) public childMenu: any;
    topNavSettings;


    @ViewChild('menuContainer', { static: false }) menuContainer!: ElementRef;

    constructor(public router: Router, private fgMenuService: FgMenuService, public dataService: DataService, private route: ActivatedRoute,   @Inject(FG_APP_CONSTANTS) public fgAppConstant: FgAppConstants,) {
        this.topNavSettings = AppSettings.topNav;
    }

// meny size adjustments
estimateItemWidth(item: any): number {
  const tempEl = document.createElement('div');
  tempEl.style.position = 'absolute';
  tempEl.style.visibility = 'hidden';
  tempEl.style.whiteSpace = 'nowrap';
  tempEl.style.fontSize = '14px'; // match your menu font

  tempEl.innerText = item.name;
  document.body.appendChild(tempEl);

  const width = tempEl.offsetWidth + 32; // add padding/margin
  tempEl.remove();

  return width;
}





    public toggleActive(menu: any, index: any): void { 

        if (menu.children && menu.children.length > 0) return;
        var app = { "appId": this.fgMenuService.appId };

        if ( this.fgAppConstant["AppUtills"].isNotNull( this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId))) {
            var pageUrl =  this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId);

            this.router.navigate([`${pageUrl}`]);
        } else {
            let detailParams: NavigationExtras = {
                queryParams: {
                    menu : menu
                }
            };
            var pageUrl: any =  this.fgAppConstant["StudioUtills"].getPageUrl(menu, app, this.router.url);
            this.router.navigate([`${pageUrl}`], {  state: { id: detailParams } });
        }
    }

    public getNamedPageUrl(menu: any, index: any) {
        let pageUrl = null;
        if (menu.children && menu.children.length > 0) return;
        var app = { "appId": this.fgMenuService.appId };

        if ( this.fgAppConstant["AppUtills"].isNotNull( this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId))) {
            pageUrl =  this.fgAppConstant["StudioUtills"].getNamedPageUrl(menu.pageId);
            // this.router.navigate([`${pageUrl}`]);
        } else {
            pageUrl =  this.fgAppConstant["StudioUtills"].getPageUrl(menu, app, this.router.url);
            // this.router.navigate([`${pageUrl}`]);
        }
        return pageUrl;
    }

    isActiveMenu(pageId: any, menu?: any): boolean {
        const currentUrl = this.router.url;
        if (menu) {
            if (menu.pageId) return currentUrl.includes(menu.pageId);
            if (menu.corePageUrl) return currentUrl.includes(menu.corePageUrl);
            if (menu.url) return currentUrl.includes(menu.url);
            if (menu.name) return currentUrl.includes(menu.name);
        }
        return pageId ? currentUrl.includes(pageId) : false;
    }
}
